/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRule
 */
export interface InternalApiScreeningClearanceRule {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRule
     */
    handle?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRule
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRule
     */
    details: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiScreeningClearanceRule
     */
    screeningType: InternalApiEntityType;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningClearanceRule
     */
    enabled: boolean;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiScreeningClearanceRule
     */
    lastUpdatedBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningClearanceRule
     */
    lastUpdatedTime?: Date;
}



/**
 * Check if a given object implements the InternalApiScreeningClearanceRule interface.
 */
export function instanceOfInternalApiScreeningClearanceRule(value: object): value is InternalApiScreeningClearanceRule {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('screeningType' in value) || value['screeningType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRuleFromJSON(json: any): InternalApiScreeningClearanceRule {
    return InternalApiScreeningClearanceRuleFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRule {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'] == null ? undefined : json['handle'],
        'reason': json['reason'],
        'details': json['details'],
        'screeningType': InternalApiEntityTypeFromJSON(json['screeningType']),
        'enabled': json['enabled'],
        'lastUpdatedBy': json['lastUpdatedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['lastUpdatedBy']),
        'lastUpdatedTime': json['lastUpdatedTime'] == null ? undefined : (new Date(json['lastUpdatedTime'])),
    };
}

export function InternalApiScreeningClearanceRuleToJSON(json: any): InternalApiScreeningClearanceRule {
    return InternalApiScreeningClearanceRuleToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRuleToJSONTyped(value?: InternalApiScreeningClearanceRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'reason': value['reason'],
        'details': value['details'],
        'screeningType': InternalApiEntityTypeToJSON(value['screeningType']),
        'enabled': value['enabled'],
        'lastUpdatedBy': InternalApiUserBasicDetailsToJSON(value['lastUpdatedBy']),
        'lastUpdatedTime': value['lastUpdatedTime'] == null ? value['lastUpdatedTime'] : value['lastUpdatedTime'].toISOString(),
    };
}

